import { apiClient } from "../apiClient";

export const getRegistrationStatus = async (serialNumber) => {
    return apiClient.get(`/Registration/GetRegistrationStatus?serialNumber=${encodeURIComponent(serialNumber)}`);
};

export const submitRegistration = async (payload) => {
    return apiClient.post(`/Registration/SubmitRegistration`, payload);
};

export const submitSurvey = async (payload) => {
    return apiClient.post(`/Survey/SendSurveyResponse`, payload);
};
